import { useTranslation } from 'react-i18next';
import classes from './List.module.scss';
import image from '../../../assets/img/Plumbing/list.avif';

const list = [
    'plumbing.list.li_01',
    'plumbing.list.li_02',
    'plumbing.list.li_03',
    'plumbing.list.li_04',
    'plumbing.list.li_05',
    'plumbing.list.li_06',
    'plumbing.list.li_07',
];

const List = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <img className={classes.image} src={image} alt='' />
                <div className={classes.body}>
                    <h2 className={`${classes.title} font-48`}>
                        {t('plumbing.list.title')}
                    </h2>
                    <ul className={`${classes.list} font-16`}>
                        {list.map((li, index) =>
                            <li key={index}>
                                {t(li)}
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default List;
